import React from 'react';

const SettingListItem = ({ itemName, buttonTitle, buttonAction, iconName, active, onSelect, itemDescription }) => {
    
    // Theme Colors based on your previous UI improvements
    const themeColor = "#4F46E5"; // Modern Indigo
    const borderColor = "#E2E8F0"; // Soft gray border
    
    const itemStyle = {
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: `1px solid ${active ? themeColor : borderColor}`,
        borderRadius: '12px',
        marginBottom: '12px',
        backgroundColor: active ? '#F8FAFC' : '#FFFFFF',
        boxShadow: active ? '0 4px 6px -1px rgba(79, 70, 229, 0.1)' : 'none',
        padding: '16px'
    };

    const iconBoxStyle = {
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        backgroundColor: active ? themeColor : '#F1F5F9',
        transition: 'all 0.2s ease'
    };

    return (
        <div style={itemStyle} onClick={onSelect} className="config-item-container">
            <div className="d-flex align-items-center justify-content-between">
                
                <div className="d-flex align-items-center">
                    {/* Icon Section */}
                    <div className="mr-3" style={iconBoxStyle}>
                        <i className={`${iconName}`} style={{ 
                            fontSize: '20px', 
                            color: active ? '#FFFFFF' : themeColor 
                        }}></i>
                    </div>

                    {/* Text Section */}
                    <div>
                        <div style={{ 
                            fontWeight: '600', 
                            fontSize: '15px', 
                            color: '#1A202C',
                            marginBottom: '2px' 
                        }}>
                            {itemName}
                        </div>
                        <div style={{ maxWidth: '50vw' }}>
                            <p className="mb-0" style={{ 
                                fontSize: '13px', 
                                color: active ? themeColor : '#64748B',
                                wordBreak: 'break-all'
                            }}>
                                {itemDescription}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Action Section */}
                <div className="ml-3">
                    {buttonTitle && (
                        <button 
                            className="btn shadow-none" 
                            style={{
                                borderRadius: '8px',
                                fontSize: '12px',
                                fontWeight: '600',
                                border: `1px solid ${themeColor}`,
                                backgroundColor: 'transparent',
                                color: themeColor,
                                padding: '6px 16px',
                                transition: '0.2s'
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // Prevent triggerring onSelect
                                buttonAction();
                            }}
                        >
                            {buttonTitle}
                        </button>
                    )}
                </div>
            </div>

            <style>{`
                .config-item-container:hover {
                    border-color: ${themeColor} !important;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
                }
                .config-item-container:hover i {
                    transform: scale(1.1);
                }
            `}</style>
        </div>
    );
};

export default SettingListItem;